import { Component } from '@angular/core'
import { Platform } from 'ionic-angular'
import { StatusBar } from '@ionic-native/status-bar'
import { SplashScreen } from '@ionic-native/splash-screen'
import { LoadingPage } from '../pages/loading/loading'
import { Keyboard } from '@ionic-native/keyboard'
import { Storage } from '@ionic/storage'

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = LoadingPage

  constructor (
    platform: Platform,
    statusBar: StatusBar,
    keyboard: Keyboard,
    private storage: Storage,
    splashScreen: SplashScreen
  ) {
    platform.ready().then(async () => {
      keyboard.setResizeMode('ionic')
      platform.registerBackButtonAction((event) => {
        event.preventDefault()
      }, 100)

      if (platform.is('cordova')) {
        if (platform.is('android')) {
          // DOMTOIMAGE WORKAROUND
          this.storage.get('reloaded').then(data => {
            if (!data) {
              this.storage.set('reloaded', true).then(() => {
                window.location.reload()
              })
            }
          })
        }
       
      }

      statusBar.hide()
      splashScreen.hide()
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts